import { Component, OnInit, Input, ViewChild, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { AuthState } from 'src/app/states/auth.state';
import { debounceTime, map, skip, takeUntil } from 'rxjs/operators';
import { combineLatest, Subject } from 'rxjs';
import { Utility, Guid } from 'src/app/core/common';
import { BoardService } from 'src/app/services/board.service';
import { CollectService } from 'src/app/services/collect.service';
import { FavoriteService } from 'src/app/services/favorite.service';
import { JobService } from 'src/app/services/job.service';
import { SharedService } from 'src/app/services/shared.service';
import { environment } from 'src/environments/environment';
import { SpinnerService } from 'src/app/services/spinner.service';
import { SubscribeSearchComponent } from 'src/app/modules/shared/components/subscribe-search/subscribe-search.component';
import { SearchBoxComponent } from 'src/app/modules/shared/components/search-box/search-box.component';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { SourceService } from 'src/app/services/source.service';
import { JobCriteria, JobSortType, ModelType, SearchParams } from 'src/app/common';


@Component({
  selector: 'app-job-list',
  templateUrl: './job-list.component.html',
  styleUrls: ['./job-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class JobListComponent implements OnInit, OnDestroy {
  user: any;
  Guid = Guid;
  topicTag: string;
  constructor(private route: ActivatedRoute, private router: Router, private jobService: JobService, private sourceService: SourceService,
    public sharedService: SharedService, private collectService: CollectService, private favoriteService: FavoriteService,
    private spinner: SpinnerService, private analyticsService: AnalyticsService, private boardService: BoardService) {
    if (this.sharedService.isBrowser)
      AuthState.user$.pipe(takeUntil(this.unsubscribe$)).subscribe(user => this.user = user);
  }

  get from() { return +(this.params.from || 0); }
  Utility = Utility;
  SearchParams = SearchParams;

  @Input() params: Params = {};

  title: string;
  jobs: any[];
  queries: string[];
  relatedPages: string[];
  relatedJobTitles: string[];
  suggestions: any;
  // advertises: any[];
  topics: any[];
  appliedParams: SearchParams;
  searchParam: SearchParams;
  didYouMean: SearchParams;
  isCanonicalDifferent: boolean;
  questionerPosition = 3;
  topicPosition = 4;
  queriesPosition = 5;
  relatedPagesPosition = 10;
  total = -1;
  current_search: string;
  current_state: string;
  current_city: string;
  current_criteria: JobCriteria = new JobCriteria();
  newDate?: Date;
  limit = 20;
  moreFrom = 0;
  loadingMore: boolean;
  favoriteIds: string[] = [];
  extraCards: {
    advertises?: any[],
    topicsInline?: any[],
    topicsEnd?: any[],
    jobTitlesInline?: any[],
    queriesInline?: any[],
    queriesEnd?: any[],
    relatedPagesInline?: any[],
    relatedPagesEnd?: any[],
    searchParam?: boolean,
  } = {};
  sources: any[];
  source: any;

  private unsubscribe$ = new Subject<void>();
  ngOnDestroy(): void {
    this.sharedService.removeLink('rel=\'amphtml\'');
    this.sharedService.removeLink('rel=\'canonical\'');
    window.onpopstate = null;

    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  redirectedReason: string;
  async ngOnInit() {
    await this.init({ ...this.route.snapshot.params, ...this.route.snapshot.queryParams });
    if (this.sharedService.isBrowser)
      combineLatest([this.route.params, this.route.queryParams])
        .pipe(skip(1), debounceTime(1), map(_ => { return { ..._[0], ..._[1] } }), takeUntil(this.unsubscribe$))
        .subscribe(async combinedParams => {
          await this.init(combinedParams);
        });
  }

  private async init(combinedParams: { [x: string]: any; }) {
    this.redirectedReason = combinedParams.r;
    this.newDate = combinedParams._new ? new Date(combinedParams._new) : null;
    await this.load(combinedParams);
    if (this.sharedService.isBrowser) {
      if (combinedParams.id)
        this.router.navigate(['/job', combinedParams.id]);
    }
  }

  private async load(params: Params) {
    this.spinner.show('list');
    this.searching = true;

    this.setSearchParams(params);

    await this.search();

    this.setSeo();
    this.moreFrom = this.from + this.limit;

    if (this.sharedService.isBrowser) {
      this.collectService.jobSearch(this.params.q, this.params.l, Object.assign({}, this.route.snapshot.queryParams, { from: this.moreFrom, limit: this.limit }));
      // this.ampAction = params['amp_action'];
    }

    if (this.appliedParams?.src) {
      this.sources = await this.sourceService.sources$.toPromise();
      this.source = this.sources.find(_ => _.Title == this.appliedParams.src);
    }
    else delete this.source;

    delete this.searching;
    this.spinner.hide('list');
  }

  // ampAction: string;
  @ViewChild('subscribeSearch') subscribeSearch: SubscribeSearchComponent;
  @ViewChild('searchBox') searchBox: SearchBoxComponent;

  // async ngAfterViewChecked() {
  //   if (this.ampAction)
  //     await this.callAmpAction();
  // }

  // private async callAmpAction() {
  //   var action = this.ampAction;
  //   delete this.ampAction;
  //   switch (action) {
  //     case 'subscribe':
  //       await this.subscribeSearch?.toggleSubscribe(true);
  //       break;
  //     case 'search-q':
  //       this.searchBox?.open('keyword');
  //       break;
  //     case 'search-l':
  //       this.searchBox?.open('location');
  //       break;
  //     case 'loadmore':
  //       this.loadMore();
  //       break;
  //   }
  //   this.router.navigate([], {
  //     relativeTo: this.route,
  //     queryParams: { 'amp_action': undefined },
  //     replaceUrl: true,
  //     queryParamsHandling: 'merge',
  //   });
  // }

  private setSearchParams(params: Params) {
    this.params = Object.assign({}, params);
    if (!this.params.l || this.params.l == 'null' || this.params.l == 'undefined') {
      delete this.params.l;
    }
    if (!this.params.q || this.params.q == 'null' || this.params.q == 'undefined') {
      delete this.params.q;
    }
    else {
      delete this.params.b;
    }
    if (!this.params.qs) {
      delete this.params.qs;
    }

    this.criteria = JobCriteria.fromParams(this.params, this._criteria_options);
    if (this.newDate) this.criteria.Sort = JobSortType.StartTime;
    this.searchParam = <SearchParams>params;
  }

  get state() {
    return Utility.getLocation(this.params.l).State;
  }
  get city() {
    return Utility.getLocation(this.params.l).City;
  }

  private _criteria_options: any = {};
  criteria: JobCriteria = new JobCriteria();
  jobsDesc: string = '';
  searching: boolean;

  private async search(more = false) {
    let result: any;
    var jobs: any[];
    if (!more) {
      this.current_criteria = this.criteria;
    }

    this.current_search = this.params.q;
    this.current_state = this.state;
    this.current_city = this.city;
    this.breadcrumbData = Utility.getBreadcrumb(this.current_state, this.current_city, this.current_search);

    if (!this.params.b) {
      this.criteria.PaidJobsCount = this._criteria_options.PaidJobsCount = 5;
      this.criteria.AllowSearchFallback = this._criteria_options.AllowSearchFallback = true;
      this.criteria.AppendExpired = this._criteria_options.AppendExpired = true;
      this.criteria.IncludeQueries = this._criteria_options.IncludeQueries = true;
      this.criteria.IncludeRelatedPages = this._criteria_options.IncludeRelatedPages = true;
      this.criteria.IncludeSuggestions = this._criteria_options.IncludeSuggestions = true;
      this.criteria.IncludeTopics = this._criteria_options.IncludeTopics = true;
      this.criteria.IncludeJobTitles = this._criteria_options.IncludeJobTitles = true;
      this.criteria.IncludeAdvertise = this._criteria_options.IncludeAdvertise = true;
      result = await this.jobService.search(this.criteria, !more ? this.from : this.moreFrom, this.limit);
      if (!result) return;
      this.title = JobService.getPageTitle(result.appliedParams, true, true);
      this.jobsDesc = result.searchDescription;
      if (result.paidJobs?.length) {
        result.paidJobs.forEach(_ => _._IsSponsored = !_.IsPaid && !_.IsKarpashaJob);
        jobs = [
          ...(result.paidJobs?.slice(0, 3)),
          ...(result.jobs?.slice(0, 7)),
          ...(result.paidJobs?.slice(3)),
          ...(result.jobs?.slice(7)),
        ];
      }
      else jobs = result.jobs;
      if (result.expiredJobs?.length)
        jobs.push(...result.expiredJobs);

    } else {
      result = await this.boardService.jobs(this.params.b, this.from, this.limit);
      if (result.board) {
        this.params = Object.assign({}, this.params, { l: Utility.join('،', result.board.State, result.board.City) });
      }
      jobs = result.jobs;
    }

    const favIds = jobs.map(_ => _.Id);
    const favs = await this.favoriteService.search({ ItemIds: favIds });
    if (favs) {
      this.favoriteIds.push(...favs.favorites.map(_ => _.ItemId));
      this.favoriteIds = Utility.distinct(this.favoriteIds);
    }

    this.total = result.total + (result.paidJobs?.length || 0);
    this.current_criteria = this.criteria;
    this.queries = result.queries;
    this.relatedPages = result.relatedPages;
    this.relatedJobTitles = result.relatedJobTitles;
    // this.advertises = result.advertises;
    this.suggestions = result.suggestions;
    this.topics = result.topics;
    this.topicTag = result.topicTag;
    this.searchParam = <SearchParams>Utility.removeEmpty(result.searchParams);
    this.jobService.lastSearch = this.appliedParams = <SearchParams>Utility.removeEmpty(result.appliedParams);
    this.didYouMean = <SearchParams>Utility.removeEmpty(result.didYouMean);

    if (more && this.jobs) {
      this.jobs.push(...jobs);
      if (jobs?.length)
        this.sharedService.scrollIntoView('#job-' + jobs[0].Id, 'start');
    }
    else { this.jobs = jobs; }

    var groupedTitles = Utility.groupBy(this.jobs, 'Title');
    var duplicateTitles = Object.keys(groupedTitles).filter(_ => groupedTitles[_].length > 1);
    if (duplicateTitles.length) {
      for (var job of jobs)
        if (duplicateTitles.includes(job.Title))
          job._duplicate = true;
    }

    // if (this.advertises?.length) {
    //   this.extraCards.advertises = this.advertises.slice(0, 1);
    //   this.analyticsService.gtmEvent('advertise-view', 'seeker', this.extraCards.advertises[0].Title || this.extraCards.advertises[0].Id);
    // }
    if (this.topics?.length) {
      var inlined = false
      if (this.jobs.length > this.topicPosition) {
        this.extraCards.topicsInline = this.topics.slice(0, 5);
        inlined = this.extraCards.topicsInline.length > 0;
      }
      this.extraCards.topicsEnd = this.topics.slice(inlined ? 5 : 0, 10);
    }
    if (this.queries?.length) {
      var inlined = false
      if (this.jobs.length > this.queriesPosition) {
        this.extraCards.queriesInline = this.queries.slice(0, 5);
        inlined = this.extraCards.queriesInline.length > 0;
      }
      this.extraCards.queriesEnd = this.queries.slice(inlined ? 5 : 0, 10);
    }
    if (this.relatedPages?.length) {
      var inlined = false
      if (this.jobs.length > this.relatedPagesPosition) {
        this.extraCards.relatedPagesInline = this.relatedPages.slice(0, 5);
        inlined = this.extraCards.relatedPagesInline.length > 0;
      }
      this.extraCards.relatedPagesEnd = this.relatedPages.slice(inlined ? 5 : 0, 10);
    }
    if (this.relatedJobTitles?.length)
      this.extraCards.jobTitlesInline = this.relatedJobTitles;

    this.extraCards.searchParam = !!this.searchParam;
  }

  private setSeo() {
    this.sharedService.setTitle(this.title);
    this.sharedService.setDescriptionMeta(this.jobsDesc);
    this.sharedService.setKeywordsMeta('استخدام', 'آگهی استخدام', 'اگهی استخدام', 'فرصت‌های شغلی', this.params?.q, this.params?.l);

    this.setCanonical();

    this.setPagingLinks();

    this.sharedService.resetNoIndex();
  }
  breadcrumbData: any;

  private setPagingLinks() {
    this.sharedService.removeLink('rel=\'prev\'');
    this.sharedService.removeLink('rel=\'next\'');

  }

  private setCanonical() {

    const canonicalTree = this.router.parseUrl(this.appliedParams?._Url || this.searchParam?._Url || this.sharedService.currentUrl);
    let canonical = this.router.serializeUrl(canonicalTree);

    if (!this.newDate) //don't set canonical if newDate exists (came from matching)
      this.isCanonicalDifferent = this.sharedService.currentUrl && Utility.trimChar(this.sharedService.currentUrl, '/') != Utility.trimChar(canonical, '/');

    if (this.appliedParams?._mode && this.appliedParams._mode != "jobtitle") //do not change canonical on non-jobtitle fallback
      canonical = this.sharedService.currentUrl;

    this.sharedService.removeLink('rel=\'canonical\'');
    this.sharedService.addLink({ rel: 'canonical', href: environment.app.url + canonical });

    let ampLink = this.router.createUrlTree([], { queryParams: this.criteria, relativeTo: this.route });
    // this.sharedService.addLink({ rel: 'amphtml', href: environment.app.url + '/amp/job?' + this.router.serializeUrl(ampLink).split('?')[1] });

  }

  getUrl(params: { params?: any, queryParams?: any }) {
    return this.router.serializeUrl(this.router.createUrlTree([params.params], { queryParams: params.queryParams, relativeTo: this.route }));
  }

  async loadMore() {
    if (!this.jobs || this.loadingMore) { return; }
    this.loadingMore = true;
    this.spinner.show('more');
    try {
      if (this.moreFrom >= this.total) { return; }
      await this.search(true);

      this.setSeo();

      this.moreFrom += this.limit;
    } finally {
      delete this.loadingMore;
      this.spinner.hide('more');
    }
  }
  getPage(from: number) {
    let params = JobService.getSearchUrlParams(this.searchParam || this.params);

    if (!from) { delete params.queryParams.from; }
    else params.queryParams.from = from;
    return params;
  }

  trackByFn(item) { return item.Id }

  async setFavorite(job: any | string, e?: boolean) {
    var index = this.favoriteIds.indexOf(job.Id);
    if (index < 0)
      this.favoriteIds.push(typeof (job) == 'string' ? job : job.Id);
    else
      this.favoriteIds.splice(index, 1);

    if (e == undefined) {
      e = await this.favoriteService.toggle({
        ItemId: job.Id,
        Type: ModelType.Job,
        ExpirationTime: job.ExpirationTime,
        Item: {
          title: job.Title,
          company: job.Company,
          state: job.State,
          city: job.City
        }
      });
    }

    if (typeof (e) == 'boolean') {
      index = this.favoriteIds.indexOf(job.Id);
      if (e && index < 0) {
        this.favoriteIds.push(typeof (job) == 'string' ? job : job.Id);
      } else if (!e && index >= 0) {
        this.favoriteIds.splice(index, 1);
      }
    }
  }

  toggleCampaign(campaign: string) {
    if (this.params.cmp == campaign)
      delete this.params.cmp;
    else
      this.params.cmp = campaign;
    this.router.navigate([this.params], { relativeTo: this.route });
  }

  getTitle(params: any) {
    return JobService.getPageTitle(params || new SearchParams());
  }

  getTitleFromUrl(url: string) {
    var params = SearchParams.parse(url);
    return JobService.getPageTitle(params, false);
  }

  hasQuestion: boolean;
  scrollToQuestioner() {
    this.sharedService.scrollIntoView('app-questioner');
    delete this.hasQuestion;
  }


  minClick = Math.floor(Math.random() * 20) + 20;
  get jobClickCount() {
    return +localStorage.getItem('job-click-count');
  }
  // _startAsk = false;
  // get askNps() { return this._startAsk && this.jobClickCount >= this.minClick; }
  addJobClick() {
    localStorage.setItem('job-click-count', (parseInt(localStorage.getItem('job-click-count')) || 0) + 1 + '');
    // this._startAsk = true;
  }
}
